<!--  -->
<template>
  <div class="layout">
    <div id="exportPdf"
         ref="exportPdf"
         v-if="
        formInline.BadgeType !=
        '海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor'
      ">
      <Form ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="left"
            :label-width="110">
        <FormItem label="证件类型："
                  :required="true">
          <Select v-model="formInline.BadgeType"
                  @on-change="change">
            <Option v-for="item in typeList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="公司名称："
                  prop="CompanyName">
          <Input type="text"
                 v-model="formInline.CompanyName"
                 placeholder="请输入公司名"></Input>
        </FormItem>
        <FormItem label="展位号："
                  prop="BoothCode">
          <Input type="text"
                 v-model="formInline.BoothCode"
                 placeholder="请输入展位号"></Input>
        </FormItem>
        <FormItem label="本人证件照："
                  prop="CardPicture">
          <div class="my-upload-list"
               v-for="(item, index) in uploadList1"
               :key="'upload' + index"
               style="
              width: 100px;
              height: 100px;
              line-height: 100px;
              margin-bottom: 0;
            ">
            <template v-if="item.status === 'finished'">
              <img :src="item.url"
                   style="width: 100%; height: 100%" />
              <div class="my-upload-list-cover">
                <Icon type="ios-eye-outline"
                      @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr1(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Spin v-if="item.showProgress"
                    style="width: 100px; height: 100px">
                <Icon type="ios-loading"
                      size="20"
                      class="demo-spin-icon-load"></Icon>
              </Spin>
            </template>
          </div>
          <Upload ref="upload1"
                  :show-upload-list="false"
                  :on-success="handleSuccess1"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload1"
                  type="drag"
                  :action="uploadUrl"
                  multiple
                  style="display: inline-block; width: 100px"
                  v-show="uploadList1 && uploadList1.length < 1">
            <div style="
                width: 100px;
                height: 100px;
                padding-top: 15px;
                color: rgb(133, 133, 133);
              ">
              <div style="font-size: 25px">
                +
                <p style="font-size: 14px">上传图片</p>
              </div>
            </div>

            <div style="
                position: absolute;
                opacity: 0;
                width: 100px;
                height: 100px;
                left: 0;
                top: 0;
              "></div>
          </Upload>
        </FormItem>
        <FormItem label="姓名："
                  prop="FirstName">
          <Input type="text"
                 v-model="formInline.FirstName"
                 placeholder="请输入姓名"></Input>
        </FormItem>
        <FormItem label="身份证号："
                  prop="IdCard">
          <Input type="text"
                 v-model="formInline.IdCard"
                 placeholder="请输入身份证号"></Input>
        </FormItem>
        <!-- <FormItem label="部门：">
              <Input type="text" v-model="formInline.Department" placeholder="请输入部门"></Input>
            </FormItem>
            <FormItem label="手机：">
              <Input type="text" v-model="formInline.Mob" placeholder="请输入手机"></Input>
            </FormItem> -->
        <FormItem label="电话："
                  prop="Tel"
                  :required="true">
          <Input type="text"
                 v-model="formInline.Tel"
                 placeholder="请输入电话"></Input>
        </FormItem>

        <FormItem label="邮箱："
                  prop="Email"
                  :required="true">
          <Input type="text"
                 v-model="formInline.Email"
                 placeholder="请输入邮箱"></Input>
        </FormItem>
        <FormItem label="验证码"
                  class="form-code-item"
                  prop="Code"
                  :required="true">
          <Input type="text"
                 v-model="formInline.Code"
                 placeholder="请输入手机验证码" />
          <Button type="text"
                  v-if="showCode"
                  @click="getCaptchaMob"
                  class="form-code-btn">获取手机验证码</Button>
          <Button type="text"
                  v-else
                  disabled
                  class="form-code-btn">{{ count }}s后重新获取</Button>
        </FormItem>
        <FormItem label="职务："
                  prop="JobTitle"
                  :required="true">
          <Input type="text"
                 v-model="formInline.JobTitle"
                 placeholder="请输入职务"></Input>
        </FormItem>

        <FormItem>
          <!-- <Button style="width:90px;" type="primary" :loading="loading" @click="handleSubmit('formInline',0)">继续添加</Button> -->
          <Button style="width: 90px"
                  type="primary"
                  :loading="loading2"
                  @click="handleSubmit('formInline', 1)">完成</Button>
          <!-- <Button style="width:90px;" type="primary" @click="cancel">取消</Button> -->
        </FormItem>
      </Form>
    </div>
    <!--海外-->
    <div v-else>
      <Form ref="formInline1"
            :model="formInline1"
            :rules="ruleInline"
            label-position="left">
        <div><span class="Tips">*</span>证件类型(Type of Certificate)：</div>
        <FormItem :required="true">
          <Select v-model="formInline.BadgeType"
                  @on-change="change">
            <Option v-for="item in typeList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <div><span class="Tips">*</span>公司名称(Company):</div>
        <FormItem label=""
                  prop="CompanyName">
          <Input type="text"
                 v-model="formInline1.CompanyName"
                 placeholder="请输入公司名">
          </Input>
        </FormItem>
        <div><span class="Tips">*</span>展位号(Booth Number)：</div>
        <FormItem label=""
                  prop="BoothCode">
          <Input type="text"
                 v-model="formInline1.BoothCode"
                 placeholder="请输入展位号"></Input>
        </FormItem>
        <!-- <FormItem label="地址：">
              <Input type="text" v-model="formInline.Address" placeholder="请输入地址"></Input>
            </FormItem> -->
        <div>本人证件照(ID Photo):</div>
        <FormItem label=""
                  prop="CardPicture">
          <div class="my-upload-list"
               v-for="(item, index) in uploadList1"
               :key="'upload' + index"
               style="
              width: 100px;
              height: 100px;
              line-height: 100px;
              margin-bottom: 0;
            ">
            <template v-if="item.status === 'finished'">
              <img :src="item.url"
                   style="width: 100%; height: 100%" />
              <div class="my-upload-list-cover">
                <Icon type="ios-eye-outline"
                      @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr1(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Spin v-if="item.showProgress"
                    style="width: 100px; height: 100px">
                <Icon type="ios-loading"
                      size="20"
                      class="demo-spin-icon-load"></Icon>
              </Spin>
            </template>
          </div>
          <Upload ref="upload1"
                  :show-upload-list="false"
                  :on-success="handleSuccess1"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload1"
                  type="drag"
                  :action="uploadUrl"
                  multiple
                  style="display: inline-block; width: 100px"
                  v-show="uploadList1 && uploadList1.length < 1">
            <div style="
                width: 100px;
                height: 100px;
                padding-top: 15px;
                color: rgb(133, 133, 133);
              ">
              <div style="font-size: 25px">
                +
                <p style="font-size: 14px">上传图片</p>
              </div>
            </div>
            <!-- 蒙版 -->
            <div style="
                position: absolute;
                opacity: 0;
                width: 100px;
                height: 100px;
                left: 0;
                top: 0;
              "></div>
          </Upload>
        </FormItem>
        <div><span class="Tips">*</span>姓名(Name):</div>
        <FormItem label=""
                  prop="FirstName">
          <Input type="text"
                 v-model="formInline1.FirstName"
                 placeholder="请输入姓名"></Input>
        </FormItem>

        <div><span class="Tips">*</span>电话(Phone Number):</div>
        <FormItem label=""
                  prop="TelEn">
          <Input type="text"
                 v-model="formInline1.TelEn"
                 placeholder="请输入电话"></Input>
        </FormItem>
        <div><span class="Tips">*</span>邮箱(Email):</div>
        <FormItem label=""
                  prop="Email">
          <Input type="text"
                 v-model="formInline1.Email"
                 placeholder="请输入邮箱"></Input>
        </FormItem>
        <div><span class="Tips">*</span>验证码(Verification Code)：</div>
        <FormItem label=""
                  class="form-code-item"
                  prop="Code">
          <Input type="text"
                 v-model="formInline1.Code"
                 placeholder="请输入邮箱验证码(Please enter the verification code)" />
          <Button type="text"
                  v-if="showCode"
                  @click="getCaptcha"
                  class="form-code-btn">Click here for a verification code</Button>
          <Button type="text"
                  v-else
                  disabled
                  class="form-code-btn">{{ count }}s后重新获取</Button>
        </FormItem>

        <div><span class="Tips">*</span>职务(Position):</div>
        <FormItem label=""
                  prop="JobTitle">
          <Input type="text"
                 v-model="formInline1.JobTitle"
                 placeholder="请输入职位(Position)"></Input>
        </FormItem>
        <div><span class="Tips">*</span>部门(Department):</div>
        <FormItem label=""
                  prop="Department">
          <Input type="text"
                 v-model="formInline1.Department"
                 placeholder="请输入部门"></Input>
        </FormItem>
        <div><span class="Tips">*</span>国家/地区(Country/Region):</div>
        <FormItem label=""
                  v-if="CountryList.length"
                  prop="Country">
          <Select v-model="formInline1.Country">
            <Option v-for="item in CountryList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <div>
          <span class="Tips">*</span>
          护照号/港澳台通行证号(Passport No. / Hong Kong, Macau and Taiwan Exit
          & Entry Permit No):
        </div>
        <FormItem label=""
                  prop="IdCardEn">
          <Input type="text"
                 v-model="formInline1.IdCardEn"
                 placeholder="请输入护照号/港澳台通行证号"></Input>
        </FormItem>
        <div>
          <!-- <span class="Tips">*</span> -->
          护照号/港澳台通行证照片( Photo of Passport / Hong Kong, Macao and
          Taiwan Exit & Entry Permit):
        </div>
        <FormItem label=""
                  prop="Img">
          <div class="my-upload-list"
               v-for="(item, index) in uploadList"
               :key="'upload' + index"
               style="
              width: 100px;
              height: 100px;
              line-height: 100px;
              margin-bottom: 0;
            ">
            <template v-if="item.status === 'finished'">
              <img :src="item.url"
                   style="width: 100%; height: 100%" />
              <div class="my-upload-list-cover">
                <Icon type="ios-eye-outline"
                      @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Spin v-if="item.showProgress"
                    style="width: 100px; height: 100px">
                <Icon type="ios-loading"
                      size="20"
                      class="demo-spin-icon-load"></Icon>
              </Spin>
            </template>
          </div>
          <Upload ref="upload"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  type="drag"
                  :action="uploadUrl"
                  multiple
                  style="display: inline-block; width: 100px"
                  v-show="uploadList && uploadList.length < 1">
            <div style="
                width: 100px;
                height: 100px;
                padding-top: 15px;
                color: rgb(133, 133, 133);
              ">
              <div style="font-size: 25px">
                +
                <p style="font-size: 14px">上传图片</p>
              </div>
            </div>
            <!-- 蒙版 -->
            <div style="
                position: absolute;
                opacity: 0;
                width: 100px;
                height: 100px;
                left: 0;
                top: 0;
              "></div>
          </Upload>
        </FormItem>
        <FormItem>
          <Button style="width: 90px; margin-right: 20px"
                  type="primary"
                  :loading="loading2"
                  @click="handleSubmitEn('formInline1', 1)">完成/Submit</Button>

        </FormItem>
      </Form>
      <div>
        海外及港澳台提示（此提示放在海外及港澳台人员实名认证入口处）：
        <br />
        海外及港澳台人员进场须知
        <br />
        尊敬的医博会参会人员您好
        <br />
        由于疫情影响，响应上海市政府及展馆的疫情防控要求，请您入场前线上完成个人信息的填写，入场时请携带护照/港澳台通行证原件。
        <br />
        您的信息只用于参观入场认证使用，感谢您的配合，祝您参展顺利！
        <br />
        中国国际医疗博览会主办方
      </div>

      <div style="margin-top: 20px">
        Notice to visitors from overseas and Hong Kong, Macao and Taiwan
        <br />
        Dear CMEF visitors,
        <br />
        <br />
        Given the anti-pandemic actions stipulated by the Shenzhen Municipal Government and Shenzhen World Exhibition & Convention Center, please fill in your identity information online before entry
        and bring the original copy of your passport/ exit-entry permit for Hong Kong, Macao and Taiwan with you while entering.
        <br />
        Your identity information is only used for authentication at the entry. Thanks for your cooperation and wish you a pleasant visit!
        <br />
        CMEF Organizing Committee
      </div>
    </div>
    <iModal title="提示"
            v-model="showTips"
            class-name="vertical-center-modal"
            width="600px"
            :mask-closable="false"
            @on-cancel="showTips = false">
      <div>提示：{{ msg }}</div>
      <div slot="footer">
        <Button style="width: 90px"
                type="primary"
                @click="confirm()">确认</Button>
        <Button style="width: 90px"
                type="primary"
                @click="showTips = false">取消</Button>
      </div>
    </iModal>
    <iModal title="提示"
            v-model="showerror"
            class-name="vertical-center-modal"
            width="600px"
            :mask-closable="false">
      <div style="font-size: 24px">尊敬的CMEF参展商您好：</div>
      <div>
        根据贵公司本届展会的展位面积，您可申请的展商证数量已达上限，如您有重要客户或重要人员需一同参会，请通过【特邀嘉宾】入口申请入场证件，感谢您的理解与配合，谢谢！
      </div>
      <div style="font-size: 12px; margin-top: 20px">
        【注】展商证申请数量规则：3张/9平米，以此类推。
      </div>
    </iModal>
    <iModal title="提示"
            v-model="showDown"
            class-name="vertical-center-modal"
            width="600px"
            :mask-closable="false"
            @on-cancel="showDown = false">
      <div>
        点击“确认”，查看认证信息，请打印并携带至展馆，进馆前需查看。(Please print the confirmation letter and bring with you before your entry)
      </div>
      <div slot="footer">
        <Button style="width: 90px"
                type="primary"
                @click="down()">确认</Button>
      </div>
    </iModal>
    <iModal title="提示"
            width="600px"
            v-model="show"
            class-name="vertical-center-modal"
            :mask-closable="false"
            @on-cancel="show=false">
      <div>
        尊敬的展商您好：第87届CMEF展商认证已截止，更多展会信息及预告请登录CMEF官网（cmef.com.cn）或CMEF官方微信公众号获取，谢谢！期待与您10月28日深圳见
      </div>

    </iModal>
  </div>
</template>

<script>
import config from '@assets/config.json'
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    const viraIdcard = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入身份证号'))
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback()
      }
    }
    const Country = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择国家'))
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback()
      }
    }
    const Img = (rule, value, callback) => {
      callback()
      // if (value === "") {
      //   callback(new Error("请上传个图片"));
      // }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      // else {

      // }
    }
    const CardPicture = (rule, value, callback) => {
      callback()
      // if (value === "") {
      //   callback(new Error("请上传个照片"));
      // }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      // else {
      //   callback();
      // }
    }
    const Tel = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (
        !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          value
        )
      ) {
        callback(new Error('请输入正确的手机号'))
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback()
      }
    }
    const Email = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱'))
      } else if (
        !/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(
          value
        )
      ) {
        callback(new Error('请输入正确的邮箱'))
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback()
      }
    }
    return {
      date1: '5月14日', // 期待见面的日子
      date2: '2023-5-12 23:59', // 提交展商认证的日子
      formInline: {
        BadgeType: '展商证',
        BadgeType2: '',
        BoothCode: '',
        CompanyName: '',
        FirstName: '',
        JobTitle: '',
        Department: '',
        Tel: '',
        Email: '',
        IdCard: '',
        Code: '',
        CardPicture: '',
      },
      formInline1: {
        BadgeType: '',
        BoothCode: '',
        CompanyName: '',
        Address: '',
        FirstName: '',
        JobTitle: '',
        Department: '',
        Img: '',
        Country: '',
        IdCardEn: '',
        Email: '',
        Code: '',
        CardPicture: '',
        TelEn: '',
      },
      ruleInline: {
        // 效验规则
        CompanyName: [
          {
            required: true,
            message: '请输入公司名',
            trigger: 'blur',
          },
        ],
        BoothCode: [
          {
            required: true,
            message: '请输入展位号',
            trigger: 'blur',
          },
        ],
        FirstName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
        ],
        IdCardEn: [
          {
            required: true,
            message: '请输入护照号',
            trigger: 'blur',
          },
        ],
        IdCard: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: 'blur',
          },
        ],

        JobTitle: [
          {
            required: true,
            message: '请输入职务',
            trigger: 'blur',
          },
        ],
        Department: [
          {
            required: true,
            message: '请输入部门',
            trigger: 'blur',
          },
        ],
        Code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur',
          },
        ],
        TelEn: [
          {
            required: true,
            message: '请输入电话号码',
            trigger: 'blur',
          },
        ],
        Email: [{ validator: Email, trigger: 'blur' }],
        Tel: [{ validator: Tel, trigger: 'blur' }],
        Country: [{ validator: Country, trigger: 'blur' }],
        Img: [{ validator: Img, trigger: 'blur' }],
        CardPicture: [{ validator: CardPicture, trigger: 'blur' }],
        // Mob: validator.phone,
      },
      typeList: [
        { label: '展商证', value: '展商证' },
        { label: '特邀嘉宾', value: '特邀嘉宾' },
        {
          label:
            '海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor',
          value:
            '海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor',
        },
      ],
      CountryList: [],
      uploadList: [], //上传图片
      uploadList1: [], //上传图片
      showTips: false,
      showerror: false,
      showCode: true, // 是否可以获取验证码
      count: '', // 获取验证码的秒数
      timer: null,
      loading2: false,
      msg: '',
      showDown: false,
      downId: false,
      show: false,
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.getCountry()
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  computed: {
    ...mapGetters({
      uploadUrl: 'getUploadUrl',
      formHeaders: 'getFormHeaders',
      exhibition: 'loginModule/getExhibition',
    }),
    exhibitonId() {
      return this.$route.query.exhibitionId
    },
  },
  methods: {
    ...mapActions({
      realAuth: 'realAuth',
      getFormDate: 'exhibitionModule/getFormDate',
      getCountryList: 'exhibitionModule/getCountryList',
      getEmailVerCode: 'exhibitionModule/getEmailVerCode',
      getMsgCode: 'exhibitionModule/getMsgCode',
      validateEmailCode: 'exhibitionModule/validateEmailCode',
      validateMsgCode: 'exhibitionModule/validateMsgCode',
      CheckRepeat: 'exhibitionModule/CheckRepeat', //查重接口
    }),
    //获取国家列表
    async getCountry() {
      let data = await this.getCountryList()
      if (data.length) {
        let arr = []
        data.forEach((e) => {
          arr.push({
            label: e.name + '/' + e.nameEn,
            value: e.name + '/' + e.nameEn,
          })
        })
        this.CountryList = arr
      }
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0]
        this.uploadList = this.$refs.upload.fileList
        this.formInline1.Img = file.url
        console.log(file.url, this.uploadList, '图片地址')
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`)
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`)
    },
    handleBeforeUpload() {
      const limitNum = 1
      const check = this.uploadList.length < limitNum
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`)
      }
      return check
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList
      this.formInline1.Img = ''
      this.uploadList.splice(fileList.indexOf(file), 1)
    },
    handleSuccess1(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0]
        this.uploadList1 = this.$refs.upload1.fileList

        if (
          this.formInline.BadgeType !=
          '海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor'
        ) {
          this.formInline.CardPicture = file.url
        } else {
          this.formInline1.CardPicture = file.url
        }

        console.log(this.uploadList1, '图片地址')
      }
    },
    handleBeforeUpload1() {
      const limitNum = 1
      const check = this.uploadList1.length < limitNum
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`)
      }
      return check
    },
    handleRemoveByArr1(file) {
      const fileList = this.uploadList1
      if (
        this.formInline.BadgeType !=
        '海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor'
      ) {
        this.formInline.CardPicture = ''
      } else {
        this.formInline1.CardPicture = ''
      }
      this.uploadList1.splice(fileList.indexOf(file), 1)
    },
    //邮箱验证码获取
    getCaptcha() {
      this.$refs.formInline1.validateField('Email', (val) => {
        console.log(val, 'valllll')
        if (val !== '') return
        this.downTime()
      })
    },
    //手机验证码验证
    getCaptchaMob() {
      this.$refs.formInline.validateField('Tel', (val) => {
        console.log(val, 'valllll')
        if (val !== '') return
        this.downTimeMob()
      })
    },
    async downTime() {
      let opt = {
        Email: this.formInline1.Email,
        Language: '3',
      }
      const valid = await this.getEmailVerCode(opt)
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.showCode = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.showCode = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    async downTimeMob() {
      let opt = {
        Phone: this.formInline.Tel,
        Language: '2',
      }
      const valid = await this.getMsgCode(opt)
      const TIME_COUNT = 60
      console.log(this.timer)
      if (!this.timer) {
        this.count = TIME_COUNT
        this.showCode = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.showCode = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    async validCode() {
      // 验证code
      if (!this.formInline1.Code) return false
      let valid = await this.validateEmailCode({
        Email: this.formInline1.Email,
        Code: this.formInline1.Code,
      })
      if (!valid) {
        this.$Message.error('验证未通过!')
        return false
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error('无效的验证码')
          return
        }
        this.$Message.error(valid.errors[0].description)
        return false
      }
      return true
    },
    //手机短信校验
    async validCodeMob() {
      // 验证code
      if (!this.formInline.Code) return false
      let valid = await this.validateMsgCode({
        Phone: this.formInline.Tel,
        Code: this.formInline.Code,
      })
      if (!valid) {
        this.$Message.error('验证未通过!')
        return false
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error('无效的验证码')
          return
        }
        this.$Message.error(valid.errors[0].description)
        return false
      }
      return true
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid)
        })
      })
    },
    down() {
      console.log(this.formInline1.BoothCode)
      this.showDown = false
      window.open(
        `${config.api.reqApi}/Pdf/GetDeExCardDownEn?Id=` +
          this.downId +
          '&BoothCode=' +
          this.formInline1.BoothCode,
        '_blank'
      )
    },
    async handleSubmit(name, e) {
      let date = '2022-08-15 23:59'
      let now = new Date().getTime()

      if (moment(now).format('YYYY-MM-DD HH:mm') > date) {
        this.show = true
        return
      }
      let form = this.formInline

      console.log(this.formInline, '提交数据')
      let valid = await this.validForm(name)
      if (!valid) return
      let validCode = await this.validCodeMob() //手机验证码验证
      if (!validCode) return
      // 实名验证
      this.loading2 = true
      let info = await this.realAuth({
        idcard: this.formInline.IdCard,
        name: this.formInline.FirstName,
      })
      if (!info || !info.successed) {
        if (!info.info) {
          this.$Message.warning(info.msg, 50)
        }
        this.loading2 = false
        return
      }

      // if (this.joinInfo.boothArea<9&&limitNumber>2){
      //   this.$Message.error("申请证件数不能超过两张");
      //   return
      // }
      // if (this.joinInfo.boothArea>=9&&limitNumber>=Math.round(this.joinInfo.boothArea/9)*3&&Math.round(this.joinInfo.boothArea/9)*3!=0){
      //   this.$Message.error("申请证件数已达上限");
      //   return
      // }

      let body = {
        ExhibitionId: this.exhibitonId,
        DeExCardDown: {
          BadgeType: form.BadgeType,
          CompanyName: form.CompanyName,
          FirstName: form.FirstName,
          JobTitle: form.JobTitle,
          Tel: form.Tel,
          Email: form.Email,
          Idcard: form.IdCard,
          BoothCode: form.BoothCode,
          CardPicture: form.CardPicture,
        },
      }
      console.log(body, '提交的数据')
      let data = await this.CheckRepeat(body)
      if (data.successed) {
        this.$http
          .post('/api/DeExCardDown/PostByExhibition', body, this.header)
          .then((res) => {
            if (res.status === 200 && res.data.successed) {
              //this.$Message.success("添加成功！");
              this.$Notice.success({
                title: '尊敬的展商您好：',
                desc: '尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会请登录CME官网（cme.com.cn)或CMEF官微信公众号进行观处预登记，谢谢！期待与您5月14日上海见！',
              })

              this.$refs['formInline'].resetFields()
              this.formInline.CompanyName = ''
              this.formInline.FirstName = ''
              this.formInline.JobTitle = ''
              this.formInline.Tel = ''
              this.formInline.Email = ''
              this.formInline.IdCard = ''
              this.formInline.CardPicture = ''
              this.$refs.upload1.fileList = []

              this.uploadList1 = []
              this.uploadList = []
              this.loading2 = false
            } else {
              this.loading2 = false
              if (res.data.msg == '申请数量已超限，无法申请') {
                this.showerror = true
              } else {
                this.$Message.warning(data.msg)
              }
            }
          })
      } else {
        this.loading2 = false
        if (data.msg !== '-1') {
          this.showTips = true
          this.msg = data.msg
        } else {
          this.$Message.error('添加失败，请重新尝试')
        }
      }
    },
    //海外版本提交表单
    async handleSubmitEn(name, e) {
      let date = new Date(this.date2).getTime()
      let now = new Date().getTime()

      if (now > date) {
        this.show = true
        return
      }
      let form = this.formInline1

      form.BadgeType =
        '海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor'
      console.log(form, '按钮点击了')
      let valid = await this.validForm(name)
      if (!valid) return
      let validCode = await this.validCode()
      if (!validCode) return
      this.loading2 = true
      let body = {
        ExhibitionId: this.exhibitonId,

        DeExCardDown: {
          Tel: form.TelEn,
          BadgeType: form.BadgeType,
          CompanyName: form.CompanyName,
          FirstName: form.FirstName,
          JobTitle: form.JobTitle,
          Country: form.Country,
          Email: form.Email,
          Img: form.Img,
          BoothCode: form.BoothCode,
          IDcard: form.IdCardEn,
          CardPicture: form.CardPicture,
          Department: form.Department,
        },
      }

      console.log(body, '数据提交')
      let data = await this.CheckRepeat(body)
      console.log(data, '查重返回')
      if (data.successed) {
        this.$http
          .post('/api/DeExCardDown/PostByExhibition', body, this.header)
          .then((res) => {
            if (res.status === 200 && res.data.successed) {
              //this.$Message.success("添加成功！");

              this.$Notice.success({
                title: '尊敬的展商您好：',
                desc: '尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会请登录CME官网（cme.com.cn)或CMEF官微信公众号进行观处预登记，谢谢！期待与您5月14日上海见！',
              })
              this.showDown = true //弹出下载PDF弹窗
              this.downId = res.data.info.id
              this.loading = false
              //this.$refs["formInline1"].resetFields();
              // this.formInline.CompanyName = "";
              this.formInline1.FirstName = ''
              this.formInline1.JobTitle = ''
              this.formInline1.TelEn = ''
              this.formInline1.Email = ''
              this.formInline1.IdCardEn = ''
              this.formInline1.Img = ''
              this.formInline1.Country = ''
              this.formInline1.CardPicture = ''
              this.formInline1.Code = ''
              this.formInline1.Department = ''
              this.$refs.upload.fileList = []
              this.$refs.upload1.fileList = []
              this.uploadList1 = []
              this.uploadList = []
              this.loading2 = false
            } else {
              this.loading2 = false
              this.$Message.error('添加失败，请重新尝试')
            }
          })
      } else {
        this.$Message.warning(data.msg)
        this.loading2 = false
      }
    },
    //确认覆盖信息
    confirm() {
      if (this.msg == '未找到公司') {
        this.showTips = false
        return
      }
      let form = this.formInline
      if (form.BadgeType == '展商证') {
        form.BadgeType2 = '特邀嘉宾'
      } else {
        form.BadgeType2 = '展商证'
      }
      let body = {
        ExhibitionId: this.exhibitonId,

        DeExCardDown: {
          BadgeType: form.BadgeType,
          CompanyName: form.CompanyName,
          FirstName: form.FirstName,
          JobTitle: form.JobTitle,
          Tel: form.Tel,
          Email: form.Email,
          Idcard: form.IdCard,
          BoothCode: form.BoothCode,
          CardPicture: form.CardPicture,
        },
      }
      this.$http
        .post('/api/DeExCardDown/PostByExhibition', body, this.header)
        .then((res) => {
          if (res.status === 200 && res.data.successed) {
            //this.$Message.success("添加成功！");

            this.$Notice.success({
              title: '尊敬的展商您好：',
              desc: '尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会请登录CME官网（cme.com.cn)或CMEF官微信公众号进行观处预登记，谢谢！期待与您5月14日上海见！',
            })

            this.showTips = false
            this.loading = false
            this.$refs['formInline'].resetFields()
            // this.formInline.CompanyName = "";
            this.formInline.FirstName = ''
            this.formInline.JobTitle = ''
            this.formInline.Tel = ''
            this.formInline.Email = ''
            this.formInline.IdCard = ''
            this.formInline.CardPicture = ''
            this.$refs.upload1.fileList = []

            this.uploadList1 = []
            this.uploadList = []
            this.loading2 = false
          } else {
            this.loading2 = false
            if (res.data.msg == '申请数量已超限，无法申请') {
              this.showerror = true
            } else {
              this.$Message.error('添加失败，请重新尝试')
            }
          }
        })
    },
    change() {
      this.formInline.FirstName = ''
      this.formInline.JobTitle = ''
      this.formInline.Tel = ''
      this.formInline.Email = ''
      this.formInline.IdCard = ''
      this.formInline.CardPicture = ''
      this.formInline.Code = ''

      if (this.$refs.upload1.fileList.length) {
        this.$refs.upload1.fileList = []
        console.log(this.$refs.upload1, '888')
      }
      if (this.$refs.upload) {
        this.$refs.upload.fileList = []
      }

      this.uploadList = []
      this.uploadList1 = []
    },
  },
}
</script>
<style scoped lang='scss'>
.Tips {
  color: red;
}
.layout {
  background-color: #fff;
  min-height: 100vh;
  padding: 10% 5%;
}
.form-code-item {
  position: relative;
  .form-code-btn {
    position: absolute;
    right: 1px;
    //width: 96px;
    height: 28px;
    top: 3px;
    border: none;
    outline: none;
    &:focus {
      box-shadow: none;
      border: none;
      outline: none;
    }
  }
}
/* @import url(); 引入css类 */
</style>